import { API_RADIO_BROADCASTERS, API_RADIO_RENTAL } from '../constants/api';
import request from './api';

export const getRadioBroadcasters = () =>
  request(`${API_RADIO_BROADCASTERS}`, {
    method: 'GET'
  });

export const getRadioStationsRented = (page, size) =>
  request(`${API_RADIO_RENTAL}?page=${page}&size=${size}&getTotal=true`, {
    method: 'GET'
  });

export const getRadioStationsRentedByParams = (
  codeRadioBroadcaster,
  fromDate,
  toDate,
  page,
  size
) =>
  request(
    `${API_RADIO_RENTAL}?codeRadioBroadcaster=${codeRadioBroadcaster}&fromDate=${fromDate}&toDate=${toDate}&page=${page}&size=${size}&getTotal=true`,
    {
      method: 'GET'
    }
  );
